import program from './program'
import { tryout } from './tryout'
import { explanation } from './explanation'
import { video } from './video'

function track(category, action, name = null, value = null) {
    window._paq.push(['trackEvent', category, action, name, value])
}

export default {
    track,

    program: program(track),
    tryout: tryout(track),
    explanation: explanation(track),
    ...video(track),
}
